import { USER_UPGRADE_CLEAR } from '@/constants/constants';
const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  /* new version accumulated usgage */
  GET_ALL_ACCUMULATED_USAGES: 'GET_ALL_ACCUMULATED_USAGES',
  SET_ALL_ACCUMULATED_USAGES: 'SET_ALL_ACCUMULATED_USAGES',
  GET_ALL_ACCUMULATED_FETCHED: 'GET_ALL_ACCUMULATED_FETCHED',
  /* MY USAGE */
  GET_MY_USAGES: 'GET_MY_USAGES',
  GET_MY_USAGES_SUCCESS: 'GET_MY_USAGES_SUCCESS',
  GET_MY_USAGES_FETCHED: 'GET_MY_USAGES_FETCHED',
  GET_MY_USAGES_FAILURE: 'GET_MY_USAGES_FAILURE',
  /* COLLECTIVE ACCUMULATED ACTIONS */
  GET_ACCUMULATED_USAGE_OF_PRODUCTS: 'GET_ACCUMULATED_USAGE_OF_PRODUCTS',
  GET_ACCUMULATED_USAGE_OF_EVERY_PRODUCTS:
    'GET_ACCUMULATED_USAGE_OF_EVERY_PRODUCTS',
  GET_ACCUMULATED_USAGE_OF_PRODUCTS_SUCCESS:
    'GET_ACCUMULATED_USAGE_OF_PRODUCTS_SUCCESS',
  GET_ACCUMULATED_USAGE_OF_EVERY_PRODUCTS_SUCCESS:
    'GET_ACCUMULATED_USAGE_OF_EVERY_PRODUCTS_SUCCESS',
  GET_ACCUMULATED_USAGE_OF_PRODUCTS_FAILURE:
    'GET_ACCUMULATED_USAGE_OF_PRODUCTS_FAILURE',
  /* ACCUMULATED ACTIONS */
  GET_ACCUMULATED_USAGE_PRODUCT_ID: 'GET_ACCUMULATED_USAGE_PRODUCT_ID',
  GET_ACCUMULATED_USAGE_PRODUCT_ID_SUCCESS:
    'GET_ACCUMULATED_USAGE_PRODUCT_ID_SUCCESS',
  GET_ACCUMULATED_USAGE_PRODUCT_ID_FAILURE:
    'GET_ACCUMULATED_USAGE_PRODUCT_ID_FAILURE',
  /* DETAILED ACTIONS */
  GET_DETAILED_USAGES_BY_TYPE_BEGINS: 'GET_DETAILED_USAGES_BY_TYPE_BEGINS',
  GET_DETAILED_USAGES_BY_TYPE_SUCCESS: 'GET_DETAILED_USAGES_BY_TYPE_SUCCESS',
  GET_DETAILED_USAGES_BY_TYPE_FAILURE: 'GET_DETAILED_USAGES_BY_TYPE_FAILURE',
  GET_DETAILED_USAGE_OF_PRODUCTS: 'GET_DETAILED_USAGE_OF_PRODUCTS',
  GET_DETAILED_USAGE_OF_PRODUCTS_SUCCESS:
    'GET_DETAILED_USAGE_OF_PRODUCTS_SUCCESS',
  GET_DETAILED_USAGE_OF_PRODUCTS_FAILURE:
    'GET_DETAILED_USAGE_OF_PRODUCTS_FAILURE',
};

export const actions = {
  /* NEW VERSION */
  getAllAccumulatedUsages: (array2Fetching, period) => ({
    type: types.GET_ALL_ACCUMULATED_USAGES,
    array2Fetching,
    period
  }),
  setAllAccumulatedUsages: (data) => ({
    type: types.SET_ALL_ACCUMULATED_USAGES,
    payload: { data },
  }),
  getAllAccumulatedUsagesFetched: () => ({
    type: types.GET_ALL_ACCUMULATED_FETCHED,
  }),
  /* GET_MY_USAGES */
  getMyUsages: (productId, period) => ({
    type: types.GET_MY_USAGES,
    productId,
    period
  }),
  getMyUsagesSuccess: (data) => ({
    type: types.GET_MY_USAGES_SUCCESS,
    payload: { data },
  }),
  getMyUsagesFailure: (data) => ({
    type: types.GET_MY_USAGES_FAILURE,
    payload: { data },
  }),
  getDetailedUsagesByType: (productId, kindProduct, pageNumber, period, optionSelected) => ({
    type: types.GET_DETAILED_USAGES_BY_TYPE_BEGINS,
    productId,
    kindProduct,
    pageNumber,
    period,
    optionSelected
  }),
  getDetailedUsagesByTypeSuccess: (data) => ({
    type: types.GET_DETAILED_USAGES_BY_TYPE_SUCCESS,
    payload: { data },
  }),
  getDetailedUsagesByTypeFailure: (data) => ({
    type: types.GET_DETAILED_USAGES_BY_TYPE_FAILURE,
    payload: { data },
  }),
  /* COLLECTIVE ACCUMULATED ACTIONS */
  /* getAccumulatedUsageOfProducts: productIds => ({
    type: types.GET_ACCUMULATED_USAGE_OF_PRODUCTS,
    productIds,
  }),
  failureGetAccumulatedUsageOfProducts: error => ({
    type: types.GET_ACCUMULATED_USAGE_OF_PRODUCTS_FAILURE,
    error,
  }),
  successGetAccumulatedUsageOfProducts: data => ({
    type: types.GET_ACCUMULATED_USAGE_OF_PRODUCTS_SUCCESS,
    payload: data,
  }), */
  /* ACCUMULATED ACTIONS */
  successGetAccumulatedUsageByProductId: (data) => ({
    type: types.GET_ACCUMULATED_USAGE_OF_PRODUCTS_SUCCESS,
    payload: data,
  }),
  failureGetAccumulatedUsageByProductId: (error) => ({
    type: types.GET_ACCUMULATED_USAGE_OF_PRODUCTS_FAILURE,
    payload: error,
  }),
  /* DETAILED ACTIONS */
  getDetailedUsageOfProducts: (productIds) => ({
    type: types.GET_DETAILED_USAGE_OF_PRODUCTS,
    productIds,
  }),
  successGetDetailedUsages: (data) => ({
    type: types.GET_DETAILED_USAGE_OF_PRODUCTS_SUCCESS,
    payload: data,
  }),
  failuregetDetailedUsageOfProducts: (error) => ({
    type: types.GET_DETAILED_USAGE_OF_PRODUCTS_FAILURE,
    payload: error,
  }),
};

export const initialState = {
  /* Flag on landing */
  allAccumulatedUsagesFetched: false,
  allAccumulatedUsagesFetching: false,
  /* accumulatedUsages where the info is */
  accumulatedUsages: [],
  fetchingMyUsages: false,
  /* detailedUsages where the info is */
  fetchingDetailedUsages: false,
  detailedUsages: [],
  /* it fill automatically when usages accumulated */
  productsCycleInfo: [],
  /* ... maybe will be deleted */
  fetching: true,
  error: false,
  detailedError: 0,
};
function reducer(state = { ...initialState }, { type, payload }) {
  switch (type) {
    case HYDRATE: {
      const { usages } = payload;
      return {
        ...state,
        ...usages,
      };
    }
    case USER_UPGRADE_CLEAR:
      return initialState;

    /* NEW VERSION */
    case types.GET_ALL_ACCUMULATED_USAGES: {
      return {
        ...state,
        allAccumulatedUsagesFetched: false,
        allAccumulatedUsagesFetching: true,
      };
    }
    case types.SET_ALL_ACCUMULATED_USAGES: {
      const { data } = payload;
      const { accUsages, allRequested, allProductsCycleInfo, period } = data;

      let newAccUsages = [...state.accumulatedUsages];
      if (accUsages && Array.isArray(accUsages)) {
        newAccUsages = [...accUsages];
      }

      let newProductsCycleInfo = [...state.productsCycleInfo];
      if (parseInt(period) === 0 || !(newProductsCycleInfo && Array.isArray(newProductsCycleInfo) && newProductsCycleInfo.length > 0)) {
        newProductsCycleInfo = [...allProductsCycleInfo];
      }
      return {
        ...state,
        accumulatedUsages: [...newAccUsages],
        productsCycleInfo: newProductsCycleInfo,
        allAccumulatedUsagesFetched: allRequested,
        allAccumulatedUsagesFetching: false,
      };
    }
    case types.GET_ALL_ACCUMULATED_FETCHED: {
      return {
        ...state,
        allAccumulatedUsagesFetching: false,
        allAccumulatedUsagesFetched: true,
      };
    }
    case types.GET_MY_USAGES:
      return {
        ...state,
        fetchingDetailedUsages: true,
        fetchingMyUsages: true,
      };
    /* GET_MY_USAGES_SUCCES */
    case types.GET_MY_USAGES_SUCCESS: {
      let dataFinal = payload.data;
      if (!dataFinal) {
        dataFinal = payload;
      }
      const { accUsages, allProductsCycleInfo, detailedUsages, productId } =
        dataFinal;
      let newAccUsages = [...state.accumulatedUsages];
      if (accUsages && Array.isArray(accUsages)) {
        newAccUsages = [...accUsages];
      }
      let newDetailedUsages = [...state.detailedUsages];
      if (detailedUsages && Array.isArray(detailedUsages)) {
        newDetailedUsages = [...detailedUsages];
      }
      const newProductCycleInfo = [...state.productsCycleInfo];
      if (
        Array.isArray(newProductCycleInfo) &&
        newProductCycleInfo.length > 0
      ) {
        const exist = newProductCycleInfo.find(
          (item) => item.productId === productId
        );
        if (!exist) {
          newProductCycleInfo.push({
            ...allProductsCycleInfo,
          });
        }
      } else {
        newProductCycleInfo.push({
          ...allProductsCycleInfo,
        });
      }
      if (newAccUsages && newAccUsages.length > 0) {
        newAccUsages.forEach((usage, index) => {
          if (usage.data && usage.data.bonus) {
            newAccUsages[index].data.bonus = usage.data.bonus.filter(
              (usg) => (usg.fb && usg.maxValue !== 50) || !usg.fb
            );
          }
        });
      }
      return {
        ...state,
        accumulatedUsages: [...newAccUsages],
        productsCycleInfo: newProductCycleInfo,
        detailedUsages: newDetailedUsages,
        fetchingDetailedUsages: false,
        fetchingMyUsages: false,
      };
    }
    case types.GET_MY_USAGES_FAILURE: {
      return {
        ...state,
        fetchingDetailedUsages: false,
        fetchingMyUsages: false,
      };
    }
    /* DETAILED */
    case types.GET_DETAILED_USAGES_BY_TYPE_BEGINS:
      return {
        ...state,
        fetchingDetailedUsages: true,
      };
    case types.GET_DETAILED_USAGES_BY_TYPE_SUCCESS: {
      let detailedUsages = payload.data;
      if (!detailedUsages) {
        detailedUsages = payload;
      }
      let detailedUsagesToState = [];
      const detailedUsagesFromState = [...state.detailedUsages];
      const haveThisDetUsage =
        detailedUsagesFromState &&
        detailedUsagesFromState.find(
          (usage) =>
            usage.productId &&
            detailedUsages.productId &&
            usage.productId === detailedUsages.productId
        );
      if (
        haveThisDetUsage &&
        Array.isArray(detailedUsagesFromState) &&
        detailedUsagesFromState.length > 0
      ) {
        detailedUsagesToState = detailedUsagesFromState.map((detailedUsage) => {
          if (detailedUsage.productId === detailedUsages.productId) {
            if (
              detailedUsage.data &&
              detailedUsage.data.length > 0 &&
              detailedUsage.data.pageNumber &&
              detailedUsage.data.pageNumber < detailedUsages.data.pageNumber
            ) {
              detailedUsage.data = [
                ...detailedUsage.data,
                ...detailedUsages.data,
              ];
              detailedUsage.data.pageNumber = detailedUsages.data.pageNumber;
              detailedUsage.data.moreElements =
                detailedUsages.data.moreElements;
              return detailedUsage;
            }
            if (
              detailedUsage.others &&
              detailedUsage.others.length > 0 &&
              detailedUsage.others.pageNumber &&
              detailedUsage.others.pageNumber < detailedUsages.others.pageNumber
            ) {
              detailedUsage.others = [
                ...detailedUsage.others,
                ...detailedUsages.others,
              ];
              detailedUsage.others.pageNumber =
                detailedUsages.others.pageNumber;
              detailedUsage.others.moreElements =
                detailedUsages.others.moreElements;
              return detailedUsage;
            }
            if (
              detailedUsage.sms &&
              detailedUsage.sms.length > 0 &&
              detailedUsage.sms.pageNumber &&
              detailedUsage.sms.pageNumber < detailedUsages.sms.pageNumber
            ) {
              detailedUsage.sms = [...detailedUsage.sms, ...detailedUsages.sms];
              detailedUsage.sms.pageNumber = detailedUsages.sms.pageNumber;
              detailedUsage.sms.moreElements = detailedUsages.sms.moreElements;
              return detailedUsage;
            }
            if (
              detailedUsage.expenses &&
              detailedUsage.expenses.length > 0 &&
              detailedUsage.expenses.pageNumber &&
              detailedUsage.expenses.pageNumber < detailedUsages.expenses.pageNumber
            ) {
              detailedUsage.expenses = [...detailedUsage.expenses, ...detailedUsages.expenses];
              detailedUsage.expenses.pageNumber = detailedUsages.expenses.pageNumber;
              detailedUsage.expenses.moreElements = detailedUsages.expenses.moreElements;
              return detailedUsage;
            }
            if (
              detailedUsage.voice &&
              detailedUsage.voice.length > 0 &&
              detailedUsage.voice.pageNumber &&
              detailedUsage.voice.pageNumber < detailedUsages.voice.pageNumber
            ) {
              detailedUsage.voice = [
                ...detailedUsage.voice,
                ...detailedUsages.voice,
              ];
              detailedUsage.voice.pageNumber = detailedUsages.voice.pageNumber;
              detailedUsage.voice.moreElements =
                detailedUsages.voice.moreElements;
              return detailedUsage;
            }
            return detailedUsages;
          }
          return detailedUsage;
        });
      } else if (
        !haveThisDetUsage &&
        Array.isArray(detailedUsagesFromState) &&
        detailedUsagesFromState.length > 0
      ) {
        detailedUsagesToState = [...detailedUsagesFromState, detailedUsages];
      } else if (
        !Array.isArray(detailedUsagesFromState) ||
        detailedUsagesFromState.length === 0
      ) {
        detailedUsagesToState.push(detailedUsages);
      }
      return {
        ...state,
        detailedUsages: detailedUsagesToState,
        fetchingDetailedUsages: false,
      };
    }
    case types.GET_DETAILED_USAGES_BY_TYPE_FAILURE: {
      return { ...state, fetchingDetailedUsages: false };
    }
    /* COLLECTIVE */
    case types.GET_ACCUMULATED_USAGE_OF_PRODUCTS:
      return { ...state };
    case types.GET_ACCUMULATED_USAGE_OF_PRODUCTS_SUCCESS: {
      if (payload.productsCycleInfo.length <= 0) {
        const usagesToAdd = [];
        payload.usages.forEach((newUsage) => {
          const newProductId = newUsage.productId;
          let isRepeated = false;
          state.accumulatedUsages.forEach((oldUsage) => {
            if (oldUsage.productId === newProductId) {
              isRepeated = true;
            }
          });

          if (!isRepeated) {
            usagesToAdd.push(newUsage);
          }
        });

        return {
          ...state,
          accumulatedUsages: [...state.accumulatedUsages, ...usagesToAdd],
        };
      }

      const newProductsCycleInfo = [];
      payload.productsCycleInfo.forEach((productCycleInfo) => {
        const { productId } = productCycleInfo;
        let alreadyExists = false;
        state.productsCycleInfo.forEach((productCycleInfoSaved) => {
          if (productCycleInfoSaved.productId === productId) {
            alreadyExists = true;
          }
        });

        if (!alreadyExists) {
          newProductsCycleInfo.push(productCycleInfo);
        }
      });

      const usagesToAdd = [];
      payload.usages.forEach((newUsage) => {
        const newProductId = newUsage.productId;
        let isRepeated = false;
        state.accumulatedUsages.forEach((oldUsage) => {
          if (oldUsage.productId === newProductId) {
            isRepeated = true;
          }
        });

        if (!isRepeated) {
          usagesToAdd.push(newUsage);
        }
      });

      return {
        ...state,
        accumulatedUsages: [...state.accumulatedUsages, ...usagesToAdd],
        productsCycleInfo: [
          ...state.productsCycleInfo,
          ...newProductsCycleInfo,
        ],
      };
    }
    case types.GET_ACCUMULATED_USAGE_OF_PRODUCTS_FAILURE:
      return { ...state, error: true };
    /* ACCUMULATED */
    case types.GET_ACCUMULATED_USAGE_PRODUCT_ID:
      return { ...state };
    case types.GET_ACCUMULATED_USAGE_PRODUCT_ID_SUCCESS:
      return { ...state, accumulatedUsages: payload };
    case types.GET_ACCUMULATED_USAGE_PRODUCT_ID_FAILURE:
      return { ...state };
    /* DETAILED */
    case types.GET_DETAILED_USAGE_OF_PRODUCTS:
      return { ...state };
    case types.GET_DETAILED_USAGE_OF_PRODUCTS_SUCCESS:
      return { ...state, detailedUsages: payload };
    case types.GET_DETAILED_USAGE_OF_PRODUCTS_FAILURE: {
      let errorCode = 999;
      if (payload && payload.response && payload.response.status === 412) {
        errorCode = 412;
      }
      return { ...state, detailedError: errorCode };
    }
    default:
      return state;
  }
}

export default reducer;
